import { render, staticRenderFns } from "./TableColumnsPopover.vue?vue&type=template&id=98d4004a&"
import script from "./TableColumnsPopover.vue?vue&type=script&lang=js&"
export * from "./TableColumnsPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports